import { RemoveNotificationsDialog, NotificationsTable } from '@pages/notifications/containers';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import { FC } from 'react';

export const Notifications: FC = () => {
  const { t } = useTranslation();
  return (
    <HasPermission permissionFeature="NOTIFICATIONS" permissionType="READ" redirect>
      <Typography className="mb-4 mt-1" variant="h300" element="h1">
        {t('NOTIFICATIONS.TITLE')}
      </Typography>

      <NotificationsTable />
      <RemoveNotificationsDialog />
    </HasPermission>
  );
};
